// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { PanelBody } from "@wordpress/components";
import { MediaPlaceholder, RichText, InspectorControls, BlockControls, MediaReplaceFlow } from "@wordpress/block-editor";
// import { MediaPlaceholder, RichText, BlockControls, MediaReplaceFlow } from "@wordpress/block-editor";
import AttributesEditor from '../../components/Gutenberg/AttributesEditor'

// Internal dependencies
import OurPeople from "./OurPeople";

// Block attributes (custom props)
const blockAttributes = {
    headline: {
        type: 'string',
        default: ''
        // default: "We work with you and the law to protect wildlife, culture, community and country."
    },
    description: {
        type: 'string',
        default: ''
        // default: "Our legal resources are designed to help you understand your rights and responsibilities in environmental matters and empower you to take the next step on important issues."
    },
    ctas: {
        type: 'array',
        default: [
            {
                image: null,
                text: "CEO",
                editText: "<a href=\"/our-people\">CEO</a>",
                target: null,
                href: "/our-people",
            },
            {
                image: null,
                text: "Board",
                editText: "<a href=\"/our-board\">Board</a>",
                target: null,
                href: "/our-board",
            },
            {
                image: null,
                text: "Team",
                editText: "<a href=\"/our-people/#hej\">Team</a>",
                target: null,
                href: "/our-people/#hej",
            },
            {
                image: null,
                text: "Programs",
                editText: "<a href=\"/our-people/#ourteams\">Programs</a>",
                target: null,
                href: "/our-people/#ourteams",
            },
        ]
    }
}

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
    const { headline, description, ctas } = attributes;
    console.log('ctas', ctas)

    const ctasWithEditable = ctas.map((cta, i) => ({
        // image: cta.image,
        image: cta.image?.id || cta.image?.url
            ? cta.image
            : <MediaPlaceholder
                onSelect={(el) => {
                    const newCtas = [...ctas];
                    newCtas[i].image = { id: el.id, url: el.url };
                    setAttributes({ ctas: newCtas });
                }}
                allowedTypes={['image']}
                multiple={false}
                labels={{ title: "Select image" }}
            />,
        text: (
            <RichText
                value={cta.editText}
                multiline={false}
                onChange={(value) => {
                    const newCtas = [...ctas];
                    newCtas[i].text = value.replace(/<\/?a[^>]*>/g, "");
                    newCtas[i].editText = value;

                    const hasLink = value.match(/href="([^"]*)/);
                    const href = hasLink ? hasLink[1] : null;
                    newCtas[i].href = href;

                    const hasTarget = value.match(/target="([^"]*)/);
                    const target = hasTarget ? hasTarget[1] : null;
                    newCtas[i].target = target;

                    const hasRel = value.match(/rel="([^"]*)/);
                    const rel = hasRel ? hasRel[1] : null;
                    newCtas[i].rel = rel;

                    setAttributes({ ctas: newCtas });
                }}
                tagName="span"
                placeholder={__("Hero Headline", "hero")}
                allowedFormats={['core/link']}
                keepPlaceholderOnFocus={true}
            />)
    }));

    return (
        <Fragment>
            <InspectorControls>
                <PanelBody title={__('')}>
                    <AttributesEditor blockAttributes={blockAttributes} attributes={attributes} setAttributes={setAttributes} />
                </PanelBody>
            </InspectorControls>
            <BlockControls group="other">
                {ctas.map((cta, i) => <MediaReplaceFlow
                    mediaId={cta.image?.id}
                    mediaURL={!cta.image?.id ? cta.image?.url : null}
                    allowedTypes={['image']}
                    accept="image/*"
                    onSelect={(media) => {
                        const newCtas = [...ctas];
                        newCtas[i].image = { id: media.id, url: media.sizes.full.url };
                        setAttributes({ ctas: newCtas });
                    }}
                    onSelectURL={(url) => {
                        const newCtas = [...ctas];
                        newCtas[i].image = { url };
                        setAttributes({ ctas: newCtas });
                    }}
                />)}
            </BlockControls>
            <OurPeople
                headline={<RichText
                    value={headline}
                    onChange={(headline) => setAttributes({ headline })}
                    placeholder={__('Headline', 'service-cta')}
                    multiline={false}
                    inlineToolbar={false}
                    tagName="span"
                    allowedFormats={[]}
                    keepPlaceholderOnFocus
                />}
                description={<RichText
                    value={description}
                    onChange={(description) => setAttributes({ description })}
                    placeholder={__('Description', 'service-cta')}
                    multiline={false}
                    inlineToolbar={false}
                    tagName="span"
                    allowedFormats={[]}
                    keepPlaceholderOnFocus
                />}
                ctas={ctasWithEditable}
            />
        </Fragment>
    );
}

// Save function (responsible for static HTML saved in database)
const save = ({ attributes }) => {
    const { headline, description, ctas } = attributes;

    return (
        <OurPeople
            headline={<RichText.Content value={headline} />}
            description={<RichText.Content value={description} />}
            ctas={ctas}
        />
    );
}

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-our-people", {

    /**
     * This is the display title for your block, which can be translated with `i18n` functions.
     * The block inserter will show this name.
     */
    title: __("Our people", "gutenberg-our-people"),

    /**
     * An icon property should be specified to make it easier to identify a block.
     * These can be any of WordPress’ Dashicons, or a custom svg element.
     */
    icon: "align-pull-left",

    /**
     * Blocks are grouped into categories to help users browse and discover them.
     * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
     */
    category: "widgets",

    /**
     * Optional block extended support features.
     */
    // supports: {
    //     // Removes support for an HTML mode.
    //     html: false
    // },
    attributes: blockAttributes,

    /**
     * The edit function describes the structure of your block in the context of the editor.
     * This represents what the editor will render when the block is used.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
     *
     * @param {Object} [props] Properties passed from the editor.
     *
     * @return {WPElement} Element to render.
     */
    edit,

    /**
     * The save function defines the way in which the different attributes should be combined
     * into the final markup, which is then serialized by the block editor into `post_content`.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
     *
     * @return {WPElement} Element to render.
     */
    save
});
